import React from 'react';
import {useSelector} from "react-redux";

import OrderItem from "../OrdersList/OrderItem/OrderItem";

const HistoryCleaningRequests = () => {
    const {historyCleaningRequests} = useSelector(state => state.cleaningRequests);

    return (
        <div style={{overflowY: 'auto', maxHeight: '1240px'}}>
            {historyCleaningRequests?.map((order, index) =>
                <OrderItem
                    handleDeleteOrder={() => ({})}
                    key={index}
                    order={order}
                    type={'history'}
                />)}
        </div>
    );
};

export default HistoryCleaningRequests;
